import {Box, Stack, Typography, useTheme} from "@mui/material";
import React, {ReactNode} from "react";

export function SeatingPlanTabCount({count, active}: {
    count: number | string,
    active: boolean,
}) {
    const theme = useTheme();
    const color = active ? theme.palette.primary : theme.palette.secondary;
    return count !== '' ? (
        <Typography variant="caption" sx={{
            ml: 1,
            px: 1,
            backgroundColor: active ? theme.palette.primary.main : theme.palette.grey["400"],
            color: color.contrastText,
            borderRadius: "4px"
        }}>{count}</Typography>
    ) : null;
}

export function SeatingPlanTabLabel({label, active, count}: {
    label: ReactNode,
    active: boolean,
    count?: number | string,
}) {
    return (
        <Stack direction="row" alignItems="center">
            <Box>{label}</Box>
            {count !== undefined && (
                <SeatingPlanTabCount count={count} active={active}/>
            )}
        </Stack>
    );
}